export { default as SvgIcon } from './SvgIcon';
